import React from 'react';
import ChartExport from '../chartExport/chartExport';

// styles
import './chartLegend.scss';

interface ChartLegendProps {
    onExport: () => void;
}

const ChartLegend = (props: ChartLegendProps) => {
    const handleExport = () => {
        props.onExport();
    };

    const handleOpen = () => {
        window.document.body.style.top = `-${window.scrollY}px`;
        window.document.body.classList.add('dataMethodologyPopup-open');
        var popup = document.querySelector('.dataMethodologyPopup');
        var backdrop = document.querySelector('.dataMethodologyPopup-backdrop');

        if (backdrop) {
            backdrop.style.display = 'block';
        }
        if (popup) {
            popup.style.display = 'block';
        }
    };

    return (
        <div className="chartLegend">
            <span>IWP – Swiss Inequality Database</span>
            <a href="javascript:void(0);" onClick={handleOpen}>
                Daten & Methode
            </a>
            <ChartExport onClick={handleExport} />
        </div>
    );
};

export default ChartLegend;
